// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =======================================================
   NAVBAR
======================================================= */
.navbar {
  position: fixed;
  top: 0;
  left: 230px;
  width: calc(100% - 230px);
  height: 65px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 24px;

  background: #0f172a;

  border-bottom: 1px solid rgba(255,255,255,0.08);

  box-shadow: 0 4px 20px rgba(0,0,0,0.15);

  z-index: 1000;

  transition: all 0.3s ease;
}

.collapsed-navbar {
  left: 60px;
  width: calc(100% - 60px);
}

/* =======================================================
   LEFT
======================================================= */
.navbar-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.collapse-btn {
  width: 40px;
  height: 40px;

  border: none;
  border-radius: 10px;

  background: rgba(255,255,255,0.08);

  color: #fff;

  font-size: 18px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.25s ease;
}

.collapse-btn:hover {
  background: #2563eb;
  transform: scale(1.05);
}

/* =======================================================
   RIGHT
======================================================= */
.navbar-right {
  display: flex;
  align-items: center;
  gap: 18px;
}

/* =======================================================
   WELCOME TEXT
======================================================= */
.welcome-text {
  font-size: 15px;
  font-weight: 500;
  color: #f8fafc;
  white-space: nowrap;
}

/* =======================================================
   NOTIFICATION
======================================================= */
.notification-wrapper {
  position: relative;
}

.notification-btn {
  width: 42px;
  height: 42px;

  border: none;
  border-radius: 12px;

  background: rgba(255,255,255,0.08);

  color: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 18px;

  cursor: pointer;

  transition: all 0.25s ease;

  position: relative;
}

.notification-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.notification-count {
  position: absolute;
  top: -5px;
  right: -5px;

  min-width: 18px;
  height: 18px;

  padding: 0 5px;

  border-radius: 999px;

  background: #ef4444;
  color: #fff;

  font-size: 11px;
  font-weight: 700;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 2px solid #0f172a;
}

/* =======================================================
   DROPDOWN
======================================================= */
.notification-dropdown {
  position: absolute;
  top: 55px;
  right: 0;

  width: 360px;
  max-height: 420px;

  overflow-y: auto;

  background: #ffffff;

  border-radius: 16px;

  box-shadow:
    0 10px 25px rgba(0,0,0,0.15),
    0 4px 10px rgba(0,0,0,0.08);

  border: 1px solid #e5e7eb;

  z-index: 1000;

  animation: dropdownAnimation 0.25s ease;
}

@keyframes dropdownAnimation {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =======================================================
   SCROLLBAR
======================================================= */
.notification-dropdown::-webkit-scrollbar {
  width: 6px;
}

.notification-dropdown::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}

/* =======================================================
   CLEAR ALL
======================================================= */
.clear-all-wrapper {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;

  display: flex;
  justify-content: flex-end;
}

.clear-all-btn {
  border: none;
  background: #ef4444;
  color: #fff;

  padding: 8px 14px;

  border-radius: 8px;

  font-size: 12px;
  font-weight: 600;

  cursor: pointer;

  transition: all 0.25s ease;
}

.clear-all-btn:hover {
  background: #dc2626;
}

/* =======================================================
   NOTIFICATION ITEM
======================================================= */
.notification-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;

  padding: 14px 16px;

  border-bottom: 1px solid #f1f5f9;

  transition: all 0.2s ease;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item:hover {
  background: #f8fafc;
}

.notification-item.unread {
  background: #eff6ff;
}

.notification-content {
  flex: 1 1;
  cursor: pointer;
}

.notification-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.notification-description {
  font-size: 12.5px;
  color: #64748b;
  margin-top: 4px;
  line-height: 1.5;
}

/* =======================================================
   DELETE BUTTON
======================================================= */
.delete-btn {
  border: none;
  background: transparent;

  color: #ef4444;

  cursor: pointer;

  font-size: 15px;

  transition: all 0.2s ease;
}

.delete-btn:hover {
  transform: scale(1.1);
}

/* =======================================================
   EMPTY STATE
======================================================= */
.no-notification {
  padding: 30px 20px;
  text-align: center;

  color: #64748b;
  font-size: 14px;
}

/* =======================================================
   LOGOUT
======================================================= */
.logout {
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 10px 16px;

  border-radius: 10px;

  background: rgba(255,255,255,0.08);

  color: #f8fafc;

  text-decoration: none;
  font-size: 14px;
  font-weight: 500;

  cursor: pointer;

  transition: all 0.25s ease;
}

.logout:hover {
  background: #ef4444;
  color: #fff;
}

/* =======================================================
   POPUP
======================================================= */
.popup-overlay {
  position: fixed;
  inset: 0;

  background: rgba(0,0,0,0.45);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 2000;

  backdrop-filter: blur(4px);
}

.popup-box {
  width: 340px;

  background: #fff;

  border-radius: 16px;

  padding: 24px;

  text-align: center;

  box-shadow: 0 12px 30px rgba(0,0,0,0.18);

  animation: popupAnimation 0.25s ease;
}

@keyframes popupAnimation {
  from {
    opacity: 0;
    transform: scale(0.92);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.popup-box p {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
}

.popup-actions {
  margin-top: 22px;

  display: flex;
  justify-content: center;
  gap: 14px;
}

.confirm-btn,
.cancel-btn {
  min-width: 100px;

  padding: 10px 14px;

  border: none;
  border-radius: 10px;

  font-size: 14px;
  font-weight: 600;

  cursor: pointer;

  transition: all 0.25s ease;
}

.confirm-btn {
  background: #ef4444;
  color: #fff;
}

.confirm-btn:hover {
  background: #dc2626;
}

.cancel-btn {
  background: #e2e8f0;
  color: #0f172a;
}

.cancel-btn:hover {
  background: #cbd5e1;
}

/* =======================================================
   MOBILE
======================================================= */
@media (max-width: 768px) {

  .navbar {
    left: 0;
    width: 100%;
    padding: 0 14px;
  }

  .collapsed-navbar {
    left: 0;
    width: 100%;
  }

  .welcome-text {
    display: none;
  }

  .notification-dropdown {
    width: 320px;
    right: -20px;
  }

  .logout span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;;yDAEyD;AACzD;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,YAAY;;EAEZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,eAAe;;EAEf,mBAAmB;;EAEnB,+CAA+C;;EAE/C,uCAAuC;;EAEvC,aAAa;;EAEb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,mBAAmB;;EAEnB,kCAAkC;;EAElC,WAAW;;EAEX,eAAe;EACf,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;yDAEyD;AACzD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,mBAAmB;;EAEnB,kCAAkC;;EAElC,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;;EAEf,eAAe;;EAEf,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,eAAe;EACf,YAAY;;EAEZ,cAAc;;EAEd,oBAAoB;;EAEpB,mBAAmB;EACnB,WAAW;;EAEX,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,yBAAyB;AAC3B;;AAEA;;yDAEyD;AACzD;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;;EAER,YAAY;EACZ,iBAAiB;;EAEjB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,mBAAmB;;EAEnB;;+BAE6B;;EAE7B,yBAAyB;;EAEzB,aAAa;;EAEb,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;yDAEyD;AACzD;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,gCAAgC;;EAEhC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;;EAEX,iBAAiB;;EAEjB,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;;EAEhB,eAAe;;EAEf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;;EAET,kBAAkB;;EAElB,gCAAgC;;EAEhC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;yDAEyD;AACzD;EACE,YAAY;EACZ,uBAAuB;;EAEvB,cAAc;;EAEd,eAAe;;EAEf,eAAe;;EAEf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;yDAEyD;AACzD;EACE,kBAAkB;EAClB,kBAAkB;;EAElB,cAAc;EACd,eAAe;AACjB;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,kBAAkB;;EAElB,mBAAmB;;EAEnB,kCAAkC;;EAElC,cAAc;;EAEd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;;EAEhB,eAAe;;EAEf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;yDAEyD;AACzD;EACE,eAAe;EACf,QAAQ;;EAER,4BAA4B;;EAE5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,aAAa;;EAEb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;;EAEZ,gBAAgB;;EAEhB,mBAAmB;;EAEnB,aAAa;;EAEb,kBAAkB;;EAElB,wCAAwC;;EAExC,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;;EAEhB,kBAAkB;;EAElB,YAAY;EACZ,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;;EAEhB,eAAe;;EAEf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;;EAEE;IACE,OAAO;IACP,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* =======================================================\n   NAVBAR\n======================================================= */\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 230px;\n  width: calc(100% - 230px);\n  height: 65px;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  padding: 0 24px;\n\n  background: #0f172a;\n\n  border-bottom: 1px solid rgba(255,255,255,0.08);\n\n  box-shadow: 0 4px 20px rgba(0,0,0,0.15);\n\n  z-index: 1000;\n\n  transition: all 0.3s ease;\n}\n\n.collapsed-navbar {\n  left: 60px;\n  width: calc(100% - 60px);\n}\n\n/* =======================================================\n   LEFT\n======================================================= */\n.navbar-left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.collapse-btn {\n  width: 40px;\n  height: 40px;\n\n  border: none;\n  border-radius: 10px;\n\n  background: rgba(255,255,255,0.08);\n\n  color: #fff;\n\n  font-size: 18px;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  transition: all 0.25s ease;\n}\n\n.collapse-btn:hover {\n  background: #2563eb;\n  transform: scale(1.05);\n}\n\n/* =======================================================\n   RIGHT\n======================================================= */\n.navbar-right {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n\n/* =======================================================\n   WELCOME TEXT\n======================================================= */\n.welcome-text {\n  font-size: 15px;\n  font-weight: 500;\n  color: #f8fafc;\n  white-space: nowrap;\n}\n\n/* =======================================================\n   NOTIFICATION\n======================================================= */\n.notification-wrapper {\n  position: relative;\n}\n\n.notification-btn {\n  width: 42px;\n  height: 42px;\n\n  border: none;\n  border-radius: 12px;\n\n  background: rgba(255,255,255,0.08);\n\n  color: #ffffff;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 18px;\n\n  cursor: pointer;\n\n  transition: all 0.25s ease;\n\n  position: relative;\n}\n\n.notification-btn:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n.notification-count {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n\n  min-width: 18px;\n  height: 18px;\n\n  padding: 0 5px;\n\n  border-radius: 999px;\n\n  background: #ef4444;\n  color: #fff;\n\n  font-size: 11px;\n  font-weight: 700;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: 2px solid #0f172a;\n}\n\n/* =======================================================\n   DROPDOWN\n======================================================= */\n.notification-dropdown {\n  position: absolute;\n  top: 55px;\n  right: 0;\n\n  width: 360px;\n  max-height: 420px;\n\n  overflow-y: auto;\n\n  background: #ffffff;\n\n  border-radius: 16px;\n\n  box-shadow:\n    0 10px 25px rgba(0,0,0,0.15),\n    0 4px 10px rgba(0,0,0,0.08);\n\n  border: 1px solid #e5e7eb;\n\n  z-index: 1000;\n\n  animation: dropdownAnimation 0.25s ease;\n}\n\n@keyframes dropdownAnimation {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* =======================================================\n   SCROLLBAR\n======================================================= */\n.notification-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n\n.notification-dropdown::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 20px;\n}\n\n/* =======================================================\n   CLEAR ALL\n======================================================= */\n.clear-all-wrapper {\n  padding: 12px;\n  border-bottom: 1px solid #f1f5f9;\n\n  display: flex;\n  justify-content: flex-end;\n}\n\n.clear-all-btn {\n  border: none;\n  background: #ef4444;\n  color: #fff;\n\n  padding: 8px 14px;\n\n  border-radius: 8px;\n\n  font-size: 12px;\n  font-weight: 600;\n\n  cursor: pointer;\n\n  transition: all 0.25s ease;\n}\n\n.clear-all-btn:hover {\n  background: #dc2626;\n}\n\n/* =======================================================\n   NOTIFICATION ITEM\n======================================================= */\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n\n  padding: 14px 16px;\n\n  border-bottom: 1px solid #f1f5f9;\n\n  transition: all 0.2s ease;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-item:hover {\n  background: #f8fafc;\n}\n\n.notification-item.unread {\n  background: #eff6ff;\n}\n\n.notification-content {\n  flex: 1;\n  cursor: pointer;\n}\n\n.notification-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.notification-description {\n  font-size: 12.5px;\n  color: #64748b;\n  margin-top: 4px;\n  line-height: 1.5;\n}\n\n/* =======================================================\n   DELETE BUTTON\n======================================================= */\n.delete-btn {\n  border: none;\n  background: transparent;\n\n  color: #ef4444;\n\n  cursor: pointer;\n\n  font-size: 15px;\n\n  transition: all 0.2s ease;\n}\n\n.delete-btn:hover {\n  transform: scale(1.1);\n}\n\n/* =======================================================\n   EMPTY STATE\n======================================================= */\n.no-notification {\n  padding: 30px 20px;\n  text-align: center;\n\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* =======================================================\n   LOGOUT\n======================================================= */\n.logout {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  padding: 10px 16px;\n\n  border-radius: 10px;\n\n  background: rgba(255,255,255,0.08);\n\n  color: #f8fafc;\n\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n\n  cursor: pointer;\n\n  transition: all 0.25s ease;\n}\n\n.logout:hover {\n  background: #ef4444;\n  color: #fff;\n}\n\n/* =======================================================\n   POPUP\n======================================================= */\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n\n  background: rgba(0,0,0,0.45);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  z-index: 2000;\n\n  backdrop-filter: blur(4px);\n}\n\n.popup-box {\n  width: 340px;\n\n  background: #fff;\n\n  border-radius: 16px;\n\n  padding: 24px;\n\n  text-align: center;\n\n  box-shadow: 0 12px 30px rgba(0,0,0,0.18);\n\n  animation: popupAnimation 0.25s ease;\n}\n\n@keyframes popupAnimation {\n  from {\n    opacity: 0;\n    transform: scale(0.92);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.popup-box p {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.popup-actions {\n  margin-top: 22px;\n\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n}\n\n.confirm-btn,\n.cancel-btn {\n  min-width: 100px;\n\n  padding: 10px 14px;\n\n  border: none;\n  border-radius: 10px;\n\n  font-size: 14px;\n  font-weight: 600;\n\n  cursor: pointer;\n\n  transition: all 0.25s ease;\n}\n\n.confirm-btn {\n  background: #ef4444;\n  color: #fff;\n}\n\n.confirm-btn:hover {\n  background: #dc2626;\n}\n\n.cancel-btn {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.cancel-btn:hover {\n  background: #cbd5e1;\n}\n\n/* =======================================================\n   MOBILE\n======================================================= */\n@media (max-width: 768px) {\n\n  .navbar {\n    left: 0;\n    width: 100%;\n    padding: 0 14px;\n  }\n\n  .collapsed-navbar {\n    left: 0;\n    width: 100%;\n  }\n\n  .welcome-text {\n    display: none;\n  }\n\n  .notification-dropdown {\n    width: 320px;\n    right: -20px;\n  }\n\n  .logout span {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
